import { DeviceVariable, I4BBulkOperationApiResponse } from '@iot-platform/models/i4b';
import { createActionGroup, props } from '@ngrx/store';

export const DeviceVariablesActions = createActionGroup({
  source: 'DeviceVariables',
  events: {
    'Load Device Variables': props<{ deviceId: string }>(),
    'Load Device Variables Success': props<{ response: DeviceVariable[] }>(),
    'Load Device Variables Failure': props<{ error: unknown }>(),

    'Reset Device Variables Last Value': props<{ variablesIds: string[] }>(),
    'Reset Device Variables Last Value Success': props<{ response: I4BBulkOperationApiResponse }>(),
    'Reset Device Variables Last Value Failure': props<{ error: unknown }>(),

    'Delete Device Variables': props<{ variablesIds: string[] }>(),
    'Delete Device Variables Success': props<{ response: I4BBulkOperationApiResponse }>(),
    'Delete Device Variables Failure': props<{ error: unknown }>()
  }
});
